import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface UndeleteGLCodeRequest {
  glCodes?: any[];
}

export interface UndeleteApiResponseData {
  processedIds: number[];
  unProcessed:
    | {
        id: number;
        errorMessage: string;
      }[]
    | [];
}

const useUndeleteGLCodeApi = (companyId: string) => {
  const call = useCallback(
    async (params?: UndeleteGLCodeRequest | undefined) => {
      try {
        if (isEmpty(params?.glCodes)) {
          throw new Error('glCodes empty');
        }
        const res = await axiosInstance.post(api.undeleteGLCode(companyId), params?.glCodes);
        return res.data as UndeleteApiResponseData;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { isLoading, execute } = useAsync<UndeleteApiResponseData, UndeleteGLCodeRequest>(
    call,
    false
  );

  return { undeleteGLCode: execute, undeleteGLCodeLoading: isLoading };
};

export default useUndeleteGLCodeApi;
